import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getPmtaSpeeds(currentPage, perPage, filter, order) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            "pmtaRelay.group.id": filter.pmtaRelayGroup.id,
            "provider.id": filter.provider.id,
            localValue: filter.localValue
        };
        parameters['order[' + order['field'] +']'] = order['asc'] ? 'asc' : 'desc';
        return axios.get(config.publicPath + 'pmta_speeds', {
            params: parameters,
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getPmtaSpeed(id) {
        return axios.get(config.publicPath + 'pmta_speeds/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    updatePmtaSpeed(id, formData) {
        return axios.put(config.publicPath + 'pmta_speeds/' + id, formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },

    createPmtaSpeed(data) {
        return axios.post(config.publicPath + 'pmta_speed/create', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    deletePmtaSpeed(ids) {
        let data = new FormData();
        data.append('pmtaSpeedsIds', JSON.stringify(ids));
        return axios.post(config.publicPath + 'pmta_speed/delete', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    syncPmtaSpeed(ids) {
        let data = new FormData();
        data.append('pmtaSpeedsIds', JSON.stringify(ids));
        return axios.post(config.publicPath + 'pmta_speed/sync', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    easyEditSpeed(relayId, providerId, localValue) {
        let queryData = new FormData();
        queryData.append('localValue', localValue);
        return axios.post(config.publicPath + 'pmta_speed/easy_edit/' + relayId + '/' + providerId, queryData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    easyDeleteSpeed(relayId, providerId) {
        return axios.post(config.publicPath + 'pmta_speed/easy_delete/' + relayId + '/' + providerId, null, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    }
}
